import { render, staticRenderFns } from "./dubbingCase.vue?vue&type=template&id=55dcff62&scoped=true"
import script from "./dubbingCase.vue?vue&type=script&lang=js"
export * from "./dubbingCase.vue?vue&type=script&lang=js"
import style0 from "./dubbingCase.vue?vue&type=style&index=0&id=55dcff62&prod&scoped=true&lang=css"
import style1 from "./dubbingCase.vue?vue&type=style&index=1&id=55dcff62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dcff62",
  null
  
)

export default component.exports